<template>
  <div class="">
    <p @click="showModal = true" class="flex items-center justify-center px-3 py-1 border-2 border-blue-300 border-transparent text-base rounded-md shadow-sm text-blue-300 bg-transparant sm:px-4 lowercase font-bold cursor-pointer">
      {{ buttonText }}
    </p>

    <modal v-if="showModal" @modal-close="showModal = false">
      <div class="h-80-vh w-auto">
        <video :src="videoSource" class="h-full w-auto" controls>
          Sorry, your browser does not support video's
        </video>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: "VideoButton",
  props: {
    videoSource: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  }
}
</script>